// KEEPING A FOOD AND BEVERAGE DIARY — single card, reuses the existing legacy asset.
import { S3 } from "./assets";

const foodDiaryCards = [
  {
    title: "Your Food and Beverage Diary",
    pdf: `${S3}/pdf/Food+and+beverage+diary.pdf`,
    thumb: `${S3}/Food+and+beverage+diary_LR.png`,
  },
];

export default foodDiaryCards;
